import React from "react";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

import { ButtonVariant } from "Constant/button";
import ClipLoader from "react-spinners/ClipLoader";

import StandartButton from "components/atoms/StandartButton";

import { COLORS } from "../../SignalWizard.constants";
import { StatusDot, wizardButtonSx } from "../../SignalWizard.styled";
import {
    Actions,
    Footer,
    FooterInner,
    StatusPill,
    StatusSlot,
} from "./WizardFooter.styled";

const WizardFooter = ({
    language,
    selectedCount,
    totalCount,
    itemLabel,
    backLabel,
    onBack,
    backTestId,
    primaryLabel,
    onPrimary,
    primaryDisabled = false,
    primaryTestId,
    isLoading = false,
}) => {
    const hasStatus = selectedCount !== undefined;

    return (
        <Footer>
            <FooterInner>
                <Actions>
                    {onBack && (
                        <StandartButton
                            variant={ButtonVariant.BLACK_OUTLINED}
                            onClick={onBack}
                            disabled={isLoading}
                            startIcon={<ArrowBackIcon />}
                            sx={wizardButtonSx}
                            data-cy={backTestId}
                        >
                            {backLabel}
                        </StandartButton>
                    )}
                </Actions>

                <StatusSlot>
                    {hasStatus && (
                        <StatusPill>
                            <StatusDot
                                $color={
                                    selectedCount
                                        ? COLORS.secondary
                                        : COLORS.outlineVariant
                                }
                            />
                            <span>
                                {selectedCount} of {totalCount} {itemLabel}{" "}
                                {language?.tracker_wizard?.selected ??
                                    "selected"}
                            </span>
                        </StatusPill>
                    )}
                </StatusSlot>

                <Actions>
                    {onPrimary && (
                        <StandartButton
                            variant="contained"
                            color="primary"
                            onClick={onPrimary}
                            disabled={primaryDisabled || isLoading}
                            endIcon={
                                isLoading ? (
                                    <ClipLoader
                                        color={COLORS.onPrimary}
                                        size={14}
                                    />
                                ) : (
                                    <ArrowForwardIcon />
                                )
                            }
                            sx={wizardButtonSx}
                            data-cy={primaryTestId}
                        >
                            {primaryLabel}
                        </StandartButton>
                    )}
                </Actions>
            </FooterInner>
        </Footer>
    );
};

export default WizardFooter;
